import React from 'react';
import styled from '@emotion/styled';
import { IWeather } from '@move-frontend/dap';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { IAirport } from '../../../../shared/api/contentful/types';

interface IWeatherRowProps {
	airport: IAirport;
	weather: IWeather;
}

export const StyledWeatherHeader = styled.div`
	font-size: 15px;
`;

export const StyledWeatherBody = styled.div``;

export const Weather = ({ weather, airport }: IWeatherRowProps) => {
	const { t } = useTranslation();
	const { city, iata } = airport;

	return (
		<>
			<StyledWeatherHeader>
				{t('flight_details_weather_header')}
			</StyledWeatherHeader>
			<StyledWeatherBody>
				{`${city} (${iata}) ${weather.temperatureImperial} `}
				{t('temperature_unit_imperial')}
			</StyledWeatherBody>
		</>
	);
};
